import React, { Component } from "react";
import { Container, Button, ModalBody, Row, Col, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
export default class CalendarHolidayListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerLoading: false,
      storeHolidayCalendar: null,
    };
  }
  componentDidMount() {
    this.getStoreHolidayCalendar();
  }
  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container
          fluid
          style={{ padding: 0, margin: 0, alignItems: "center" }}
        >
          <ModalBody>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h5 style={{ margin: 10 }}>Calendar Holidays</h5>
              <Button
                color="danger"
                style={{ margin: 10, paddingLeft: 25, paddingRight: 25 }}
                onClick={() => {
                  this.props.goBack();
                }}
              >
                Back
              </Button>
            </div>
            <Row noGutters>
              <Col
                sm="12"
                md="3"
                d="flex"
                flex="column"
                align-items="stretch"
                style={{ backgroundColor: "whitesmoke" }}
              >
                {this.state.storeHolidayCalendar &&
                  this.state.storeHolidayCalendar.map((hoilday) => {
                    return (
                      <Card
                        className={"p-0"}
                        style={{
                          display: "flex",
                          margin: 10,
                          color: "black",
                        }}
                      >
                        <p style={{ padding: 10 }}>
                          {"Date: " +
                            moment(hoilday.node.holidayDates).format(
                              "DD-MM-YYYY"
                            )}
                        </p>

                        <Button
                          style={{
                            margin: 10,
                            backgroundColor: "red",
                            color: "white",
                          }}
                          onClick={() => {
                            this.updateStoreCalendarHoliday(hoilday.node.id);
                          }}
                        >
                          Delete
                        </Button>
                      </Card>
                    );
                  })}
              </Col>
            </Row>
          </ModalBody>
        </Container>
      </LoadingOverlay>
    );
  }

  updateStoreCalendarHoliday = async (id) => {
    let requestManager = new RequestManager();

    let input = {
      input: {
        id: id,
        status: "INACTIVE",
      },
    };
    console.log("input", JSON.stringify(input));
    this.setState({ spinnerLoading: true });
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateStoreCalendarHoliday",
      input
    );

    if (response.error === null) {
      this.setState({ spinnerLoading: false });
      this.getStoreHolidayCalendar();
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update Store Status. Please check your internet connection."
      );
    }
  };

  getStoreHolidayCalendar = async () => {
    this.setState({ spinnerLoading: true });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getStoreHolidayCalendar",
      {
        storeIds: storeInformation.store.id,
      }
    );
    console.log("getStoreHolidayCalendar", JSON.stringify(response));
    if (response.error === null) {
      this.setState({
        storeHolidayCalendar: response.data.storeHolidayCalendar.edges,
        spinnerLoading: false,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/CalendarHolidayListModal/CalendarHolidayListModal.js